<div class="ai-feedback-actions" aria-label="Assistant response actions">
  <button type="button" aria-label="Helpful">
    <i class="ki-filled ki-like"></i>
  </button>
  <button type="button" aria-label="Not helpful">
    <i class="ki-filled ki-dislike"></i>
  </button>
  <button type="button" aria-label="Inspect prompt" (click)="openAudit()">
    <i class="ki-filled ki-row-horizontal"></i>
  </button>
  <button type="button" aria-label="Copy response">
    <i class="ki-filled ki-copy"></i>
  </button>
</div>
